import Area from "../assets/area.json"
import { Area as IArea } from "@/interface/common"

// 是否为省
const isProvince = (code: string) => code.slice(2) === '0000'
// 是否为市
const isCity = (code: string) => code.slice(4) === '00'
// 往省里新增市往市里新增区
const push = (provinceOrCity: IArea, areaItem: IArea) => {
  const { children } = provinceOrCity
  if (children) {
    children.push(areaItem)
  } else {
    provinceOrCity.children = [areaItem]
  }
}
// 省，市，区
export const getAreaData = () => {
  const data: Array<IArea> = []
  let currentProvince: IArea;
  let currentCity: IArea;
  Object.entries(Area).forEach(([code, name]) => {
    const areaItem: IArea = { label: name, value: code }
    // 省
    if (isProvince(code)) {
      currentProvince = areaItem
      data.push(areaItem)
    } else if (isCity(code)) {
      // 市
      currentCity = areaItem
      push(currentProvince, areaItem)
    } else {
      // 区
      push(currentCity, areaItem)
    }
  })
  return data;
}

export const clearCookies = () => {
  const reg = /[^ =;]+(?==)/g
  const keys = document.cookie.match(reg);
  if (keys) {
    for (let i = keys.length; i--;) {
      document.cookie = keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString();//清除当前域名下的,例如：m.kevis.com
      document.cookie = keys[i] + '=0;path=/;domain=' + document.domain + ';expires=' + new Date(0).toUTCString();//清除当前域名下的，例如 .m.kevis.com
      document.cookie = keys[i] + '=0;path=/;domain=kevis.com;expires=' + new Date(0).toUTCString();//清除一级域名下的或指定的，例如 .kevis.com
    }
  }
}